import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import RealtimeScanner from "../../../Images/real-time-market-scanner.png";
import Ultrafastorderexecution from "../../../Images/ultra-fast-order-execution.png";
import Dynamicpricewatchlist from "../../../Images/dynamic-price-watchlist.png";
import "./EasyTrade.css";
function EasyTrade() {
  return (
    <>
      <section className="easy-trade">
        <Container className="add-border">
          <Row>
            <Col md={12}>
              <h1>Trading made easy for you!</h1>
            </Col>
          </Row>
          <div className="trademadeeasy_section">
          <Row>
            <Col md={6}>
              <div className="box-shadow">
              <img
                className="img-fluid"
                src={Ultrafastorderexecution}
                alt="Ultrafastorderexecution"
              />
              </div>
            </Col>
            <Col md={6}>
              <div className="each-trade">
              <h3>Ultra-fast order execution</h3>
                <p>
                Lightning fast trade execution by a rock solid platforms
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={{ span: 6, order: "first" }} xs={{ order: "last" }}>
              <div className="each-trade">
              <h3>Powerful Charting and Real time Market Screeners</h3>
                <p>With real-time market screeners and interactive charts, you can trade on the go.</p>
              </div>
            </Col>
            <Col md={6} sm={{ span: 6, order: "last" }} xs={{ order: "first" }}>
              <div className="box-shadow realtime_screener">
              <img
                className="img-fluid"
                src={RealtimeScanner}
                alt="RealtimeScanner"
              />
            
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="box-shadow">
              <img
                className="img-fluid"
                src={Dynamicpricewatchlist}
                alt="Dynamicpricewatchlist"
              />
              </div>
            </Col>
            <Col md={6}>
              <div className="each-trade">
                <h3>Multiple watch list and Dynamic Price Alerts</h3>
                <p>
                Set personalised price notifications for your favorite stock.
                </p>
              </div>
            </Col>
          </Row>
          </div>
        </Container>
      </section>
    </>
  );
}
export default EasyTrade;
